/* Caviatra Gewinnspiel: Teilnahme absenden, optional Newsletter anmelden */
(function () {
  'use strict';

  function postForm(form, successParam) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    }).then(function (res) {
      return res.ok && res.url.indexOf(successParam) !== -1;
    });
  }

  function openTerms() {
    var terms = document.getElementById('teilnahmebedingungen');
    if (terms && !terms.open) terms.open = true;
  }

  function init(root) {
    var form = root.querySelector('#CvGiveawayForm');
    var nlForm = root.querySelector('#CvGiveawayNewsletterForm');
    if (!form || form.dataset.cvReady) return;
    form.dataset.cvReady = 'true';

    var button = form.querySelector('[data-giveaway-submit]');
    var fields = form.querySelector('[data-giveaway-fields]');
    var success = form.querySelector('[data-giveaway-success]');
    var emailInput = form.querySelector('[name="contact[email]"]');
    var nlCheckbox = form.querySelector('[data-giveaway-nl]');
    if (!button || !fields || !success || !emailInput) return;

    function showSuccess() {
      Array.prototype.forEach.call(form.children, function (el) {
        if (el !== success && el.tagName !== 'INPUT') el.hidden = true;
      });
      success.hidden = false;
      success.focus();
    }

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) return; // Browser zeigt die Pflichtfeld-Hinweise
      event.preventDefault();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      var wantsNewsletter = !!(nlCheckbox && nlCheckbox.checked && nlForm);

      postForm(form, 'contact_posted=true')
        .then(function (ok) {
          if (!ok) throw new Error('participation');
          if (!wantsNewsletter) return;
          nlForm.querySelector('[name="contact[email]"]').value = emailInput.value;
          // Newsletter-Fehler dürfen die Teilnahme nicht kippen
          return postForm(nlForm, 'customer_posted=true').catch(function () {});
        })
        .then(showSuccess, function () {
          // Fallback: normales Absenden ohne Skript
          button.disabled = false;
          button.removeAttribute('aria-busy');
          form.submit();
        });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href="#teilnahmebedingungen"]');
    if (link) openTerms();
  });

  if (window.location.hash === '#teilnahmebedingungen') openTerms();

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-giveaway]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
